export const SET_FILTERS = "SET_FILTERS";

interface SetFiltersAction {
    type: typeof SET_FILTERS;
    filters: {};
}

export type Action = SetFiltersAction;
export type State = { filters: object };
